define('responsive-game-feed/app/scripts/utils/tracking-gameday',['require','exports','module','responsive-gameday-tracking/responsive-gameday-tracking'],function(require, exports, module) {
 
   var Tracking = require("responsive-gameday-tracking/responsive-gameday-tracking");
	
	   return Tracking

});

